import styled from 'styled-components';

export const StyledOverlay = styled.div<{ $fullScreen?: boolean }>`
  position: fixed;
  inset: 0;
  z-index: ${({ theme }) => theme.zIndex.modal};
  display: flex;
  align-items: center;
  justify-content: center;
  padding: ${({ $fullScreen, theme }) => ($fullScreen ? 0 : theme.spacing.l)}px;
  background-color: ${({ theme }) => theme.colors.overlay};
`;

export const StyledPanel = styled.div<{ $width: number; $fullScreen?: boolean }>`
  display: flex;
  flex-direction: column;
  width: 100%;
  max-width: ${({ $width, $fullScreen }) => ($fullScreen ? 'none' : `${$width}px`)};
  height: ${({ $fullScreen }) => ($fullScreen ? '100%' : 'auto')};
  max-height: ${({ $fullScreen }) => ($fullScreen ? 'none' : '85vh')};
  background-color: ${({ theme }) => theme.colors.backgroundSecondary};
  border: ${({ $fullScreen, theme }) =>
    $fullScreen ? 'none' : `1px solid ${theme.colors.border}`};
  border-radius: ${({ $fullScreen, theme }) => ($fullScreen ? 0 : theme.borderRadius.l)}px;
  box-shadow: ${({ theme }) => theme.shadow.elevated};
  overflow: hidden;
`;

export const StyledHeader = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: ${({ theme }) => theme.spacing.m}px ${({ theme }) => theme.spacing.l}px;
  border-bottom: 1px solid ${({ theme }) => theme.colors.borderSubtle};
`;

export const StyledClose = styled.button`
  display: inline-flex;
  align-items: center;
  justify-content: center;
  width: 32px;
  height: 32px;
  background: none;
  border: none;
  border-radius: ${({ theme }) => theme.borderRadius.s}px;
  color: ${({ theme }) => theme.colors.textSecondary};
  cursor: pointer;

  &:hover {
    background-color: ${({ theme }) => theme.colors.surfaceHover};
    color: ${({ theme }) => theme.colors.textPrimary};
  }
`;

export const StyledBody = styled.div<{ $fullScreen?: boolean }>`
  flex: 1;
  min-height: 0;
  padding: ${({ theme }) => theme.spacing.l}px;
  ${({ $fullScreen }) =>
    $fullScreen ? 'display: flex; flex-direction: column; overflow: hidden;' : 'overflow-y: auto;'}
`;

export const StyledFooter = styled.div`
  display: flex;
  align-items: center;
  justify-content: flex-end;
  gap: ${({ theme }) => theme.spacing.s}px;
  padding: ${({ theme }) => theme.spacing.m}px ${({ theme }) => theme.spacing.l}px;
  border-top: 1px solid ${({ theme }) => theme.colors.borderSubtle};
`;
